import React from 'react';

import { SVGComponentProps } from './svg.types';

const FreezeColumnSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.4H6V4.19971H10V1.4ZM10 0H6H5H0V14H16V0H11H10ZM11 1.4V4.19971H15V5.59971H11V8.39917H15V9.79917H11V12.6L15 12.6V1.4H11ZM10 12.6V9.79917H6V12.6H10ZM10 8.39917V5.59971H6V8.39917H10ZM5 4.19971V1.4H1V4.19971H5ZM1 5.59971H5V8.39917H1V5.59971ZM1 9.79917H5V12.6L1 12.6V9.79917Z"
        fill={fill}
      />
      <path d="M6 14H0L0 0H6L6 14Z" fill={fill} />
    </svg>
  );
};

export default FreezeColumnSVG;
